<div
  class="menu-item"
  [class.selected]="selected()"
  [class.featured]="item().featured"
  [GenerateIdentifier]="'menu-' + item().title"
  [attr.data-testid]="'menu-item-' + item().title"
>
  <div
    class="menu-item-inner"
    [routerLink]="(!item().locked && item().url) ? item().url : null"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="onClick()"
  >
    @if (item().iconType === 'material') {
      <span
        class="material-symbols-outlined item-icon"
        [matTooltip]="iconOnly() ? (item().tooltip || item().title) : (item().tooltip || '')"
      >
        {{ item().icon }}
      </span>
    } @else if (item().monochrome) {
      <span
        class="item-icon icon-mask"
        [style.mask-image]="'url(' + item().icon + ')'"
        [style.-webkit-mask-image]="'url(' + item().icon + ')'"
        [matTooltip]="iconOnly() ? (item().tooltip || item().title) : (item().tooltip || '')"
      ></span>
    } @else {
      <img
        class="item-icon"
        [src]="item().icon"
        [matTooltip]="iconOnly() ? (item().tooltip || item().title) : (item().tooltip || '')"
        alt=""
      />
    }

    @if (!iconOnly()) {
      @if (!item().children?.length) {
        <span class="item-title">{{ item().title }}</span>
      } @else {
        <span class="item-title">{{ item().title }}</span>
        <span class="material-symbols-outlined expand-arrow">
          {{ isOpen() ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
        </span>
      }

      @if (item().pill) {
        <div class="badge green">
          <span class="badge-text">{{ item().pill }}</span>
        </div>
      }

      @if (item().locked) {
        <span class="lock-icon">🔒</span>
      } @else if (item().completionPercentage != null) {
        <div class="badge" [ngClass]="{ green: item().completionPercentage! >= 80 }">
          <span class="badge-text">{{ item().completionPercentage }}%</span>
        </div>
      }
    }
  </div>

  @if (item().children?.length && isOpen()) {
    <ul class="submenu">
      @for (child of item().children!; track child.url) {
        <li>
          <a
            [routerLink]="child.url"
            routerLinkActive="active-child"
            [routerLinkActiveOptions]="{ exact: true }"
            class="submenu-item"
          >
            {{ child.title }}
          </a>
        </li>
      }
    </ul>
  }
</div>
